import DetentoraService from '../_services/DetentoraService'
import { erroArrayToString } from '@/utils/trataErroRetornoApi'
import { detentoraModel } from '../_model/detentora'

const state = {
  loading: false,
  loadingStore: false,
  detentoras: [],
  currentPage: null,
  urlFirstPage: null,
  urlNextPage: null,
  urlPrevPage: null,
  urlLastPage: null,
  urlPath: null,
  detentoraSelecionado: undefined,
  erros: '',
  filter: null,
}

const getters = {
  GET_DETENTORAS : (state) => state.detentoras,
  GET_URL_PATH : (state) => state.urlPath,
  GET_ERROS: state => state.erros,
}

const mutations = {

  SET_LOADING_STORE: (state, ativo) => {
    state.loadingStore = ativo ? ativo : false
  },

  DETENTORA_SELECTED : (state, { detentora }) => {
    state.detentoraSelecionado = Object.assign({}, detentora)
  },

  MERGE_PESSOA: (state, { pessoa }) => {
    var objOld = Object.assign({}, state.detentoraSelecionado)
    objOld.pessoa = pessoa
    state.detentoraSelecionado = Object.assign({}, objOld)
  },

  SET_DETENTORAS : (state, { detentoras }) => {
    state.detentoras = JSON.parse(JSON.stringify(detentoras))
    state.urlFirstPage = detentoras.first_page_url
    state.urlPrevPage = detentoras.prev_page_url
    state.urlPrevPage = detentoras.prev_page_url
    state.urlLastPage = detentoras.last_page_url
    state.urlPath = detentoras.path
    state.currentPage = detentoras.current_page
  },

  SET_FILTER: (state, filter) => {
    state.filter = filter
  },

  SET_ERROS : (state, erros) => {
    state.erros = erros.erros
  },

  ERASE_ERROS : (state) => {
    state.erros = ''
  },

  RESET_SELECTED : state => state.detentoraSelecionado = undefined,

}

const actions = {

  GET_DETENTORAS : async ({ commit, state }) => {
      commit('SET_DETENTORAS', { detentoras : []})
      commit('ERASE_ERROS')
      await DetentoraService.getDetentoras(state.filter)
      .then(response => {
        if (response.data.status) {
          commit('SET_DETENTORAS', { detentoras : response.data.detentoras })
        } else if (response.data.erro) {
          commit('SET_ERROS', { erros: response.data.erro })
        }
      })
      .catch(error => {
        console.log(error)
        commit('SET_ERROS', { erros: 'Erro ao acessar api' })
      })
  },

  PAGINATE_DETENTORAS : async ({ commit }, url) => {
    commit('ERASE_ERROS')
    await DetentoraService.getPagination(url)
    .then(response => {
      if (response.data.status) {
        commit('SET_DETENTORAS', { detentoras : response.data.detentoras })
      } else if (response.data.erro) {
        commit('SET_ERROS', { erros: response.data.erro })
      }
    })
    .catch(error => {
      console.log(error)
      commit('SET_ERROS', { erros: 'Erro ao acessar api' })
    })
  },

  GET_DETENTORA : async ({commit}, id) => {
    commit('ERASE_ERROS')
    await DetentoraService.getDetentora(id)
    .then(response => {
      if (response.data.status) {
        commit('DETENTORA_SELECTED', { detentora : response.data.detentora })
      } else if (response.data.erro) {
        commit('SET_ERROS', { erros: response.data.erro })
      }
    })
    .catch(error => {
      console.log(error)
      commit('SET_ERROS', { erros: 'Erro ao acessar api' })
    })

  },

  GET_CPFCNPJ : async ({commit}, cpfcnpj) => {
    commit('ERASE_ERROS')
    if (!cpfcnpj) return
    await DetentoraService.getCpfCnpj(cpfcnpj)
    .then(response => {
      if (response.data.status) {
        var data = response.data
        if (data.detentora) {
          commit('DETENTORA_SELECTED', { detentora : response.data.detentora })
        } else if (data.pessoa) {
          commit('MERGE_PESSOA', { pessoa: data.pessoa })
        }
      } else if (response.data.erro) {
        commit('SET_ERROS', { erros: response.data.erro })
      }
    })
    .catch(error => {
      console.log(error)
      commit('SET_ERROS', { erros: 'Erro ao acessar api' })
    })
  },

  STORE_DETENTORA : async ({ commit, dispatch }, detentora) => {
    commit('ERASE_ERROS')
    try {
      commit('SET_LOADING_STORE', true)
      if (!detentora.id || !(detentora.id > 0)) { 
        var response = await DetentoraService.postDetentora(detentora)
      } else {
        var response = await DetentoraService.putDetentora(detentora.id, detentora)
      }

      if (response.data.status) {
        commit('DETENTORA_SELECTED', { detentora : response.data.detentora })
        if (state.urlPrevPage || state.urlNextPage) {
          await dispatch('PAGINATE_DETENTORAS', `${state.urlPath}?page=${state.currentPage}`)
        } else {
          await dispatch('GET_DETENTORAS')
        }

      } else if (!response.data.status && response.data.validacao) {
        var erros = erroArrayToString(response.data.erros)
        commit('SET_ERROS', { erros: erros })
      } else if (response.data.erro) {
        commit('SET_ERROS', { erros: response.data.erro })
      }

    } catch (error) {
      console.log(error)
      commit('SET_ERROS', { erros: 'Erro ao acessar api' })
    } finally {
      commit('SET_LOADING_STORE', false)
    }
  },

  DELETE_DETENTORA : async ({ commit, dispatch }, detentora) => {
    commit('ERASE_ERROS')
    try {
      var response = await DetentoraService.deleteDetentora(detentora.id)

      if (response.data.status) {
        await dispatch('GET_DETENTORAS')

      } else if (response.data.erro) {
        commit('SET_ERROS', { erros: response.data.erro })
      }

    } catch (error) {
      console.log(error)
      commit('SET_ERROS', { erros: 'Erro ao acessar api' })
      reject(error)
    }
  },

  DETENTORA_SELECTED : async ({dispatch, commit}, id) => { 
    if (id > 0) { 
      await dispatch('GET_DETENTORA', id)
    } else {
      var obj = new detentoraModel.detentora()
      await commit('DETENTORA_SELECTED', { detentora: obj })
    }
  },

  RESET_SELECTED : ( {commit} ) => { commit('RESET_SELECTED') },

}

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions,
} 


// WEBPACK FOOTER //
// ./src/views/Detentora/_store/index.js